/*
  Mobilmenyn: chevronen fäller ut underkategorierna.

  Kategorinamnet är en vanlig länk och leder till kategorin. Bara chevronen
  fäller ut, så ett tryck på namnet aldrig fastnar i en meny som bara
  öppnar sig.

  Lyssnaren ligger på dokumentet, inte på ett eget element. Temats
  modal-component flyttar lådan till <body> när den öppnas, och en
  lyssnare som satts på ett element inne i lådan följer inte alltid med
  flytten. Dokumentet finns alltid.
*/
document.addEventListener('click', (e) => {
  const knapp = e.target.closest('.tp-drawer_toggle');
  if (!knapp) return;
  e.preventDefault();

  const id = knapp.getAttribute('aria-controls');
  const lista = id ? document.getElementById(id) : null;
  if (!lista) return;

  const oppen = knapp.getAttribute('aria-expanded') === 'true';
  knapp.setAttribute('aria-expanded', oppen ? 'false' : 'true');
  lista.classList.toggle('is-open', !oppen);
});
